module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', [_c('input', {
    staticClass: "width_full no-render",
    attrs: {
      "id": "uploadInput",
      "type": "file"
    },
    on: {
      "change": _vm.uploadStart
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid-4"
  }, [_c('button', {
    staticClass: "width_full upload-button",
    class: _vm.uploadButtonClass,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.uploadInit
    }
  }, [_vm._v("\n        " + _vm._s((_vm.file) ? ("Upload File: " + (_vm.file.name)) : 'Select Excel Document') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('button', {
    staticClass: "width_full primary-green-bg",
    on: {
      "click": _vm.downloadTemplateMerchant
    }
  }, [_vm._v("\n        Download Template\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ae42754!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/Upload.vue
// module id = 380
// module chunks = 2